import { NgModule } from '@angular/core';
import { ExtraOptions, Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { HomeComponent } from './pages/home/home.component';
import { PreQuestionsComponent } from './pages/pre-steps/pre-questions/pre-questions.component';
import { QuizComponent } from './pages/quiz/quiz.component';
import { QuizResultComponent } from './pages/quiz-result/quiz-result.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { FinalResultComponent } from './pages/final-result/final-result.component';
import { EmailRedirectComponent } from './pages/email-redirect/email-redirect.component';

const routes: Routes = [
  // {
  //   path: 'pages', loadChildren: './pages/pages.module#PagesModule'
  // },
  {
    path: 'pages',
    component: PagesComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'pre-steps',
        component: PreQuestionsComponent
      },
      {
        path: 'quiz/:slug',
        component: QuizComponent
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
      },
      {
        path: 'result/:slug',
        component: QuizResultComponent
      },
      { path: '', redirectTo: 'pre-steps', pathMatch: 'full' },
      { path: '**', redirectTo: 'pre-steps' },
    ]
  },
  {
    path: 'email-redirect',
    component: EmailRedirectComponent
  },
  {
    path: 'schedule-call',
    component: FinalResultComponent
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
};
@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})

export class AppRoutingModule {

}
